import React from "react";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { isExist, compose } from "cxa-utils";
import { validateForm } from "./validation";
import { renderField } from "./components";
import { AIA_FORMS, SUBMIT_FAILURE_MESSAGE } from "../constants";
import enhance from "../hoc";

const AIA_HDF_ID = "aiaHdf";
let membersWithUWData = [];

const AiaHdf = props => {
  const {
    handleSubmit,
    submitting,
    membersWithUW,
    confirm,
    aiaForm,
    hdfid,
    isReadOnly,
    renderValue,
    onSave,
    onPrint,
    onClose,
  } = props;

  membersWithUWData = membersWithUW;
  const uwform = AIA_FORMS[hdfid];
  const handleSave = onSave(AIA_HDF_ID);
  const content = uwform.formContent(renderValue, membersWithUWData);
  const isSubmitFailed = isExist(aiaForm) && aiaForm.submitFailed;

  return (
    <div className="hdf">
      {uwform.formHeader}

      <form method="post" action="#">
        <Field component={renderField} type="hidden" name="HDFormID" />

        {content}

        {isSubmitFailed && (
          <p role="alert" className="card--alert">
            {SUBMIT_FAILURE_MESSAGE}
          </p>
        )}
        <p>
          {// @TODO 16.3.0 - Fragment
          !isReadOnly ? (
            [
              <Button primary key="save" onClick={handleSave} disabled={submitting} secondary>
                Save
              </Button>,
              <Button
                key="submit"
                submitting={submitting}
                onClick={handleSubmit(confirm)}
                disabled={submitting}
              >
                Submit & Confirm
              </Button>,
            ]
          ) : (
            <Button onClick={onPrint}>Print</Button>
          )}

          <Button onClick={onClose} disabled={submitting} secondary>
            Close
          </Button>
        </p>
      </form>
    </div>
  );
};

AiaHdf.propTypes = {
  employeeParticulars: PropTypes.object,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  confirm: PropTypes.func,
  aiaForm: PropTypes.object,
  hdfid: PropTypes.string,
  membersWithUW: PropTypes.array,
  isReadOnly: PropTypes.bool,
  renderValue: PropTypes.func,
  onSave: PropTypes.func,
  onPrint: PropTypes.func,
  onClose: PropTypes.func,
};

export default compose(
  enhance,
  reduxForm({
    form: AIA_HDF_ID,
    enableReinitialize: true,
    validate: validateForm,
  })
)(AiaHdf);



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aia/form.js